import React, { FC } from 'react';
import styled from 'styled-components';
import { BROWSER_BREAKPOINTS, CustomFieldDetails, Paper } from '@flicent/fieldpulse-react-component-library-frontend';

import JobDetailedRecordProps from './JobDetailedRecord.props';

import { JobDetails, JobFileCategories, JobNotes, JobPhotos, JobSubtasks, JobVisits } from '../index';


const StyledRoot = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-row-gap: 50px;
  font-family: 'Open Sans', sans-serif;
  scroll-margin-top: 12px;

  @media screen and ${ BROWSER_BREAKPOINTS.MOBILE } {
    grid-row-gap: 40px;
  }
`

const JobDetailedRecord: FC<JobDetailedRecordProps> = ({ job }) => {
  return (
    <Paper id={ job.cuid.toString() } as={StyledRoot}>
      <JobDetails job={ job }/>
      { job.is_custom_fields_visible && <CustomFieldDetails customFields={job.custom_fields} /> }
      <JobNotes job={ job }/>
      <JobFileCategories job={ job }/>
      <JobPhotos job={ job }/>
      <JobVisits job={ job }/>
      <JobSubtasks job={ job }/>
    </Paper>
  );
};


export default JobDetailedRecord;